module.exports = __webpack_public_path__ + "static/media/UCP-1-legacy.5a63bcb1.jpg";